constructedCategoryTaxonomy = undefined
prettyUrls = require 'pretty-urls'

_isCategoryPage = ->
  _getSelectedCategory() not in ['all-deals', 'new-deals']

_getSelectedCategoryObject = ->
  Groupon.Categories?.selectedCategory ? Groupon.PageAppData?.selectedCategory

_getSelectedCategory = ->
  selectedCategoryObject = _getSelectedCategoryObject()
  return selectedCategoryObject.id if selectedCategoryObject?.id?
  'all'

_recursivelyConstructCategoryTaxonomy = (category, categoryTaxonomy, startingLevel, rootPath=[]) ->
  {children, id} = category
  rootPath.push id
  categoryTaxonomy[id] = _constructTaxonomyNode id, startingLevel, rootPath.slice(0)

  if children?.length
    _.each children, (childCategory) ->
      _recursivelyConstructCategoryTaxonomy childCategory, categoryTaxonomy, startingLevel + 1, rootPath
  rootPath.pop()

  categoryTaxonomy

_constructCategoryTaxonomy = () ->
  categoryTaxonomy = {}
  return categoryTaxonomy if not _isCategoryPage() # no taxonomy on all-deals
  _recursivelyConstructCategoryTaxonomy _getSelectedCategoryObject(), categoryTaxonomy, 2

_constructTaxonomyNode = (id, level, rootPath) ->
  {id, level, rootPath}

_decideSelectedCategories = (enabledFacets, facetNames) ->
  if not _isCategoryPage() then []
  else
    {CATEGORY_QUERY, SUBCATEGORY_QUERY, SUBCATEGORY2_QUERY, SUBCATEGORY3_QUERY} = facetNames

    if not _.isEmpty(enabledFacets[CATEGORY_QUERY]) or
    not _.isEmpty(enabledFacets[SUBCATEGORY_QUERY]) or
    not _.isEmpty(enabledFacets[SUBCATEGORY2_QUERY]) or
    not _.isEmpty(enabledFacets[SUBCATEGORY3_QUERY])
      _.compact _.union(enabledFacets[CATEGORY_QUERY], enabledFacets[SUBCATEGORY_QUERY], enabledFacets[SUBCATEGORY2_QUERY], enabledFacets[SUBCATEGORY3_QUERY])
    else if (selectedCategoryObject = _getSelectedCategoryObject())?.id?
      [selectedCategoryObject.id]
    else
      ["all"]

_constructCollection = (collectionId, collectionType, enabledFacets, facetNames, extraQS) ->
  collectionsRoot = Groupon.urls.collections if collectionType
  delete extraQS.query

  prettyUrls.V1.construct
    baseURL: "#{collectionsRoot}/#{collectionId}"
    l2Categories: [_getSelectedCategory()] if _isCategoryPage()
    l3Categories: enabledFacets[facetNames.CATEGORY_QUERY]
    l4Categories: enabledFacets[facetNames.SUBCATEGORY_QUERY]
    l5Categories: enabledFacets[facetNames.SUBCATEGORY2_QUERY]
    l6Categories: enabledFacets[facetNames.SUBCATEGORY3_QUERY]
    interests: enabledFacets[facetNames.INTEREST_QUERY]
    brands: enabledFacets[facetNames.BRAND_QUERY]
    discounts: enabledFacets[facetNames.DISCOUNT_QUERY]
    extraQS: extraQS

_getAppRoot = ->
  Groupon.urls?.browse ? Groupon.PageAppData?.baseUrl

module.exports = BrowseUrlConstructionHelper =
  constructCollection: _constructCollection

  constructV1: (enabledFacets, facetNames, extraQS) ->
    appRoot = _getAppRoot()

    prettyUrls.V1.construct
      baseURL: appRoot
      l2Categories: [_getSelectedCategory()] if _isCategoryPage()
      l3Categories: enabledFacets[facetNames.CATEGORY_QUERY]
      l4Categories: enabledFacets[facetNames.SUBCATEGORY_QUERY]
      l5Categories: enabledFacets[facetNames.SUBCATEGORY2_QUERY]
      l6Categories: enabledFacets[facetNames.SUBCATEGORY3_QUERY]
      interests: enabledFacets[facetNames.INTEREST_QUERY]
      brands: enabledFacets[facetNames.BRAND_QUERY]
      discounts: enabledFacets[facetNames.DISCOUNT_QUERY]
      extraQS: extraQS

  constructV2: (enabledFacets, facetNames, extraQS) ->
    appRoot = _getAppRoot()
    constructedCategoryTaxonomy ?= _constructCategoryTaxonomy()
    selectedCategories =
      _.uniq _decideSelectedCategories(enabledFacets, facetNames)

    prettyUrls.V2.construct constructedCategoryTaxonomy,
      selectedCategories: selectedCategories
      selectedInterests: enabledFacets[facetNames.INTEREST_QUERY]
      selectedBrands: enabledFacets[facetNames.BRAND_QUERY]
      baseURL: appRoot
      extraQS: extraQS

  # TODO: upgrade PhantomJS or find some other .bind alternative
  getConstructCollectionById: (collectionId, collectionType) ->
    (enabledFacets, facetNames, extraQS) ->
      _constructCollection collectionId, collectionType, enabledFacets, facetNames, extraQS
